const {
  PUBLIC_URL,
  NODE_ENV,
  REACT_APP_BASE_URL,
  REACT_APP_OIDC_ISSUER,
  REACT_APP_OIDC_CLIENT_ID,
  REACT_APP_VENUE_UUID,
  REACT_APP_ORG,
} = process.env

module.exports = {
  PUBLIC_URL,
  NODE_ENV,
  BASE_URL: REACT_APP_BASE_URL,
  OIDC_ISSUER: REACT_APP_OIDC_ISSUER,
  OIDC_CLIENT_ID: REACT_APP_OIDC_CLIENT_ID,
  VENUE_ID: REACT_APP_VENUE_UUID,
  ORG_NAME: REACT_APP_ORG,
}
